import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { Box, TextField, Button, MenuItem, Typography, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface IFormInputs {
    displayName: string;
    gender: string;
    birthDate: string;
}

const CompleteProfile: React.FC = () => {
    const { updateUserClaims, user, setRequiresProfileCompletion, isUpdatingClaims } = useAuth();
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<IFormInputs>();

    const onSubmit: SubmitHandler<IFormInputs> = async (data) => {
        try {
            await updateUserClaims(data.gender, data.birthDate);
            toast.success("Профиль успешно обновлен! Перенаправление...");

            if (user) {
                await user.getIdToken(true);
            }

            setRequiresProfileCompletion(false);
            navigate("/people");
        } catch (error: any) {
            toast.error(error.message || "Ошибка при обновлении профиля");
        }
    };

    return (
        <Box sx={{ maxWidth: 400, margin: "0 auto", padding: 2 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
                Заполните недостающие данные
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)}>
                <TextField
                    select
                    label="Пол"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    {...register("gender", { required: "Выберите пол" })}
                    error={!!errors.gender}
                    helperText={errors.gender?.message}
                >
                    <MenuItem value="Мужчина">Мужчина</MenuItem>
                    <MenuItem value="Женщина">Женщина</MenuItem>
                </TextField>

                <TextField
                    label="Дата рождения"
                    type="date"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    {...register("birthDate", { required: "Выберите дату рождения" })}
                    error={!!errors.birthDate}
                    helperText={errors.birthDate?.message}
                    InputLabelProps={{ shrink: true }}
                />

                <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{ mt: 2 }}
                    disabled={isUpdatingClaims}>
                    {isUpdatingClaims ? <CircularProgress size={20} sx={{ color: 'white', mr: 1 }} /> : null} Сохранить
                </Button>
            </form>
        </Box>
    );
};

export default CompleteProfile;
